import { useModalState } from '@sequencehq/core-components'
import { CountriesAlpha2, Currency, useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { cloneElement, FC, ReactElement } from 'react'
import {
  formatPaymentDetails,
  PaymentDetailsModal
} from '@sequencehq/invoice-content'
import { useNavigate } from 'react-router-dom'

type Props = {
  currency: Currency
  country: CountriesAlpha2
  trigger: ReactElement
}

export const InvoiceMerchantDetailsModal: FC<Props> = ({
  currency,
  country,
  trigger
}) => {
  const { isModalOpen, openModal, closeModal } = useModalState()

  const navigate = useNavigate()

  const triggerWithOnClick = cloneElement(trigger, {
    onClick: (event: React.MouseEvent) => {
      if (trigger.props.onClick) {
        trigger.props.onClick(event)
      }
      openModal()
    }
  })

  const merchantDetails = useQuery(
    dashboard20240730Client.getInvoiceMerchantDetails,
    {
      currency,
      country
    }
  )

  if (!merchantDetails.data?.address) {
    return null
  }

  return (
    <>
      {triggerWithOnClick}

      <PaymentDetailsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        detailItems={formatPaymentDetails(merchantDetails.data)}
        secondaryButton={{
          text: 'Update details',
          onClick: () => {
            navigate('/settings/bank-details')
          }
        }}
      />
    </>
  )
}
